import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="main-content">
      <div className="container">
        <h1>Privacy Notice</h1>
        
        <div className="privacy-content">
          <h2>English Version</h2>
          
          <h3>Personal Information Processor</h3>
          <p>Smart Factory (Kunshan) Co., Ltd. (昆山蕴启工业智能制造实验室有限公司) is the personal information processor responsible for processing information collected through the China Readiness Check.</p>
          <p>German Industrial Park II</p>
          <p>No. 692 Depu Road, Zhangpu Town</p>
          <p>215321 Kunshan, P. R. China</p>
          <p>Phone: +86 512 3685 3980</p>
          
          <h3>Information We Process</h3>
          <p>We process the following information:</p>
          <ul>
            <li><strong>Business information:</strong> Company name, company profile information, China business activities and plans, project, facility, staffing and investment planning information, and questionnaire answers</li>
            <li><strong>Personal information:</strong> Business email address and personal information that may be entered in free-text fields</li>
            <li><strong>Technical information:</strong> IP address and related request information processed as necessary to operate and protect the website.</li>
          </ul>
          
          <h3>Sensitive Personal Information</h3>
          <p><strong>Sensitive personal information:</strong> Please do not include sensitive personal information in questionnaire free-text fields unless specifically requested. This includes, for example, identification or passport numbers, health information, bank or payment details, biometric information, or private contact information unrelated to the business inquiry.</p>
          

          
          <h3>Purposes of Processing</h3>
          <p>The information is used to:</p>
          <ul>
            <li>Operate and evaluate the China Readiness Check</li>
            <li>Assess the company's China activities, plans and potential support requirements</li>
            <li>Review and evaluate the submitted China Readiness Check</li>
            <li>Maintain security and technical operation of the service</li>
            <li>Contact the submitting company regarding the submitted China Readiness Check, discuss the potential China project and coordinate relevant next steps</li>
          </ul>
          <p>This project-related follow-up does not include unrelated advertising or general marketing communications.</p>
          
          <h3>Processing Methods</h3>
          <p>Personal information is collected through the questionnaire, stored, reviewed and analyzed by authorized personnel for the purposes described above, and deleted after the retention period expires.</p>
          
          <h3>Retention Period</h3>
          <p>Questionnaire submissions are retained for up to 24 months unless a shorter retention period is required by law or the information must be deleted earlier under applicable legal requirements. Deleted information may remain temporarily in technical backups until those backups are overwritten or expire.</p>
          
          <h3>Additional Information</h3>
          <p>This website does not use external advertising trackers, Google Analytics, Google Tag Manager, or similar third-party tracking technologies.</p>
          
          <h3>Cookies</h3>
          <p>This website does not use advertising or analytics cookies. A technically necessary session cookie is used for authenticated access to the administration area. This cookie is required for the security and operation of the admin login and is not used for tracking or advertising.</p>
          
          <h3>Storage Location</h3>
          <p>Questionnaire personal information is stored on infrastructure located in Mainland China.</p>
          
          <h3>Recipients / Service Providers</h3>
          <p>Access to questionnaire personal information is limited to authorized personnel and technical service providers required to operate, host, secure or maintain the assessment service.</p>
          
          <h3>Access from Germany / Cross-Border Access</h3>
          <p>Authorized personnel of Startup Factory International GmbH in Germany may access personal information contained in questionnaire submissions for the purpose of reviewing and evaluating potential China projects and following up with the submitting company.</p>
          <p><strong>Foreign recipient:</strong><br/>
Startup Factory International GmbH<br/>
Freibadstr. 30<br/>
81543 Munich, Germany<br/>
Contact: Dr. Christian Haug<br/>
Phone: +49 89 30907165</p>
          <p>The information made accessible may include the business email address and other personal information contained in the questionnaire submission. Processing by the foreign recipient may include access, review and internal evaluation of the submitted information.</p>
          <p>Questions or requests concerning personal information may be directed either to Smart Factory (Kunshan) Co., Ltd. using the contact details above or to Startup Factory International GmbH using the contact details shown in this section.</p>
          
          <h3>Data Subject Rights</h3>
          <p>You may, subject to applicable law:</p>
          <ul>
            <li>Request access to your personal information</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Withdraw consent where processing is based on consent</li>
            <li>Request an explanation of the processing rules</li>
          </ul>
          <p>Requests can be made using the company contact details shown above.</p>
          
          <h3>Withdrawal of Consent</h3>
          <p>Withdrawal of consent does not affect processing already carried out before withdrawal.</p>
          
          <h3>Security</h3>
          <p>We use reasonable technical and organizational measures to protect personal information against unauthorized access, disclosure, alteration, or destruction.</p>
          
          <h3>Minors</h3>
          <p>The China Readiness Check is intended for business users and is not intended for minors.</p>
          
          <h3>Changes to this Privacy Policy</h3>
          <p>This Privacy Policy may be updated from time to time. The current version is published on this page.</p>
          
          <h2>中文版本</h2>
          
          <h3>个人信息处理者</h3>
          <p>昆山蕴启工业智能制造实验室有限公司（Smart Factory (Kunshan) Co., Ltd.）是负责处理《中国准备度检查》所收集信息的个人信息处理者。</p>
          <p>地址：中国江苏省昆山市张浦镇德浦路692号，昆山德国工业园二期，215321</p>
          <p>电话：+86 512 3685 3980</p>
          
          <h3>我们处理的信息</h3>
          <p>我们处理以下信息：</p>
          <ul>
            <li><strong>企业信息：</strong>公司名称、公司概况信息、在中国的业务活动和计划、项目、设施、人员配置和投资规划信息，以及问卷调查答案</li>
            <li><strong>个人信息：</strong>商务电子邮件地址以及可能在自由文本字段中输入的个人信息</li>
            <li><strong>技术信息：</strong>IP地址及相关请求信息，为运行和保护网站所必需而进行处理。</li>
          </ul>
          
          <h3>敏感个人信息</h3>
          <p><strong>敏感个人信息：</strong>请勿在问卷自由文本字段中输入敏感个人信息，除非特别要求。这包括例如身份证号或护照号码、健康信息、银行或支付详细信息、生物识别信息，或与业务咨询无关的私人联系信息。</p>
          
          <h3>处理目的</h3>
          <p>所收集的信息用于以下目的：</p>
          <ul>
            <li>运行和评估《中国准备度检查》</li>
            <li>评估公司的在华业务活动、计划及潜在支持需求</li>
            <li>审阅和评估已提交的《中国准备度检查》</li>
            <li>维护服务的安全性和技术运行</li>
            <li>就已提交的《中国准备度检查》与提交问卷的企业联系，讨论潜在的中国项目并协调相关后续步骤</li>
          </ul>
          <p>此类与项目相关的后续沟通不包括无关的广告或一般营销信息。</p>
          
          <h3>处理方式</h3>
          <p>个人信息通过问卷收集，存储，由授权人员审阅和分析用于上述目的，并在保留期届满后删除。</p>
          
          <h3>保留期限</h3>
          <p>问卷提交信息保留最长24个月，除非法律要求更短的保留期，或根据适用法律要求提前删除信息。已删除的信息可能暂时保留在技术备份中，直至这些备份被覆盖或过期。</p>
          
          <h3>存储位置</h3>
          <p>问卷个人信息存储于中国大陆境内的基础设施。</p>
          
          <h3>接收方 / 服务提供商</h3>
          <p>问卷个人信息的访问权限仅限于授权人员以及为运行、托管、保障或维护评估服务所必需的技术服务提供商。</p>
          
          <h3>德国访问 / 个人信息出境</h3>
          <p>Startup Factory International GmbH 在德国的授权人员可能访问问卷提交中包含的个人信息，用于审阅和评估潜在的中国项目以及与提交问卷的企业进行后续沟通。</p>
          <p><strong>境外接收方：</strong><br/>
Startup Factory International GmbH<br/>
Freibadstr. 30<br/>
81543 Munich, Germany<br/>
联系人：Dr. Christian Haug<br/>
电话：+49 89 30907165</p>
          <p>可供境外接收方访问的信息可能包括商务电子邮件地址以及问卷提交中包含的其他个人信息。境外接收方的处理方式可能包括访问、审阅和内部评估所提交的信息。</p>
          <p>有关个人信息的问题或权利请求，可以通过上述联系方式向昆山蕴启工业智能制造实验室有限公司提出，也可以通过本节所列联系方式向 Startup Factory International GmbH 提出。</p>
          
          <h3>数据主体权利</h3>
          <p>您可根据适用法律：</p>
          <ul>
            <li>请求访问您的个人信息</li>
            <li>请求更正不准确的信息</li>
            <li>请求删除您的个人信息</li>
            <li>在处理基于同意的情况下撤回同意</li>
            <li>请求对处理规则进行说明</li>
          </ul>
          <p>您可使用上述公司联系方式提出请求。</p>
          
          <h3>同意撤回</h3>
          <p>同意撤回不影响撤回前已进行的处理。</p>
          
          <h3>安全措施</h3>
          <p>我们采用合理的技术和组织措施保护个人信息，防止未经授权的访问、披露、篡改或销毁。</p>
          
          <h3>未成年人</h3>
          <p>《中国准备度检查》面向商业用户，不面向未成年人。</p>
          
          <h3>其他信息</h3>
          <p>本网站不使用外部广告跟踪器、Google Analytics、Google Tag Manager 或类似的第三方跟踪技术。</p>
          
          <h3>Cookies</h3>
          <p>本网站不使用广告或分析类 Cookie。管理后台的身份验证使用一个技术上必要的会话 Cookie。该 Cookie 仅用于管理后台登录的安全和正常运行，不用于跟踪或广告。</p>
          
          <h3>本隐私政策的更新</h3>
          <p>本隐私政策可能会不时更新。当前版本发布于本页面。</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;